import React from 'react';

import CheckboxFilter from 'bundles/backoffice/filters/checkbox';

import type { Filters } from './types';

const completedOption = { label: 'Completed', value: 'completed' };
const overdueOption = { label: 'Overdue', value: 'overdue' };
const openOption = { label: 'Open', value: 'open' };

type Slice = Pick<Filters, 'completed' | 'open' | 'overdue'>;
interface Props extends Slice {
  tbd: Filters['tbd'];
  onChange: (changes: Partial<Slice>) => void;
}

export default function TasksIndexFilters({ tbd, onChange, ...statuses }: Props) {
  const enabledStatuses = Object.values(statuses).filter(Boolean);

  const options = [completedOption, openOption];
  if (!tbd) {
    options.push(overdueOption);
  }

  return (
    <CheckboxFilter
      addFilter={(_, filter) => onChange({ [filter]: true })}
      className="ms-0"
      filterTag={enabledStatuses.length >= options.length ? 'Any' : null}
      hideSelectedCount={enabledStatuses.length === 0}
      label="Status"
      name="apex-tasks-list__status-filter"
      options={options}
      removeFilter={(_, filter) => onChange({ [filter]: false })}
      selected={Object.values(options).map(option => statuses[option.value] ? option.value : null).filter(Boolean)}
    />
  );
}
